import { render } from "./STFMFM02C07AddProperty.vue?vue&type=template&id=77ffe71d&scoped=true"
import script from "./STFMFM02C07AddProperty.vue?vue&type=script&lang=js"
export * from "./STFMFM02C07AddProperty.vue?vue&type=script&lang=js"

import "./STFMFM02C07AddProperty.vue?vue&type=style&index=0&id=77ffe71d&scoped=true&lang=css"

import exportComponent from "D:\\TDS\\40_製造(M)\\99_電帳法_USE\\Tatsuzin_filemanage\\vue\\tdsvue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ffe71d"]])

export default __exports__